module.exports = __webpack_public_path__ + "media/images/icons8-info-green-8bf8ea0cbd11e8cfaaa26ba5ccda1630.svg";